import { Role } from '@litlingo/client';

/* eslint-disable import/prefer-default-export */
export const DEFAULT_ROLES = ['user', 'anonymous'];

export type UserTypeKey =
  | 'endUser'
  | 'reviewer'
  | 'projectManager'
  | 'admin'
  | 'systemAdmin'
  | 'legal'
  | 'compliance'
  | 'fullReviewer';

export type UserType = { roles: Role[]; label: string };

export const userTypesMapping: Record<UserTypeKey, UserType> = {
  endUser: { roles: ['user'], label: 'End User' },
  reviewer: { roles: ['super-reviewer', 'admin'], label: 'Reviewer' },
  compliance: {
    roles: ['super-reviewer', 'admin', 'compliance-user'],
    label: 'First Pass Reviewer',
  },
  // Full Reviewer = Reviewer + Legal + Compliance (all review status options and filters)
  fullReviewer: {
    roles: ['super-reviewer', 'admin', 'compliance-user', 'legal-user'],
    label: 'Full Reviewer',
  },
  projectManager: {
    roles: ['assignment-admin', 'super-reviewer', 'admin'],
    label: 'Project Manager',
  },
  admin: { roles: ['super-reviewer', 'super-admin'], label: 'Litlingo Admin' },
  systemAdmin: { roles: ['system-admin'], label: 'System User' },
  // @ts-ignore
  legal: { roles: ['legal-user'], label: 'Second Pass Reviewer' },
};

// @ts-ignore
export const userTypesMappingSimple: Record<UserTypeKey, UserType> = {
  reviewer: { roles: ['super-reviewer'], label: 'Reviewer' },
  compliance: { roles: ['compliance-user'], label: 'First Pass Reviewer' },
  fullReviewer: {
    roles: ['super-reviewer', 'compliance-user', 'legal-user'],
    label: 'Full Reviewer',
  },
  projectManager: {
    roles: ['assignment-admin'],
    label: 'Project Manager',
  },
  legal: { roles: ['legal-user'], label: 'Second Pass Reviewer' },
};

export const userRolesGroupMapping = {
  'End User': 'end_user',
  Reviewer: 'reviewer',
  'Project Manager': 'project_manager',
  'Litlingo Admin': 'admin',
  'System User': 'system_admin',
  'Second Pass Reviewer': 'legal_user',
  'First Pass Reviewer': 'compliance_user',
  'Full Reviewer': 'full_reviewer',
};

export const selectableUserTypes = (({
  reviewer,
  projectManager,
  admin,
  endUser,
  systemAdmin,
  legal,
  compliance,
  fullReviewer,
}: typeof userTypesMapping): Partial<typeof userTypesMapping> => ({
  reviewer,
  projectManager,
  admin,
  endUser,
  systemAdmin,
  legal,
  compliance,
  fullReviewer,
}))(userTypesMapping);

export const selectableUserTypesSimple = (({
  reviewer,
  projectManager,
  legal,
  compliance,
  fullReviewer,
}: typeof userTypesMapping): Partial<typeof userTypesMapping> => ({
  reviewer,
  projectManager,
  legal,
  compliance,
  fullReviewer,
}))(userTypesMappingSimple);
